// removed by extract-text-webpack-plugin
module.exports = {"nf-messagecenter-grid":"nf-messagecenter-grid","rt-table":"rt-table","rt-td":"rt-td","rt-tbody":"rt-tbody","rt-resizable-header-content":"rt-resizable-header-content","nf-cell--capitalize":"nf-cell--capitalize","nf-cell--left-align":"nf-cell--left-align","nf-cell--link":"nf-cell--link","ReactTable":"ReactTable","rt-tr":"rt-tr","rt-thead":"rt-thead","-header":"-header","rt-th":"rt-th"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/MessageCenterGrid/MessageCenterGrid.scss
// module id = 5070
// module chunks = 1